import { FC } from 'react';
import { Button } from '@new/common/ui/Button/Button';

interface CourseBuilderFooterProps {
  selectedCount: number;
  selectedCredits: number;
  onCancel: () => void;
  onAdd: () => void;
}

export const CourseBuilderFooter: FC<CourseBuilderFooterProps> = ({
  selectedCount,
  selectedCredits,
  onCancel,
  onAdd,
}) => {
  const courseLabel = selectedCount === 1 ? 'Course' : 'Courses';

  return (
    <div className="flex flex-col shrink-0 gap-4">
      <hr className="m-0! border-(--neutral-black-NB100)" />

      <div className="flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="m-0! text-(--neutral-black-NB700)! [font-size:var(--fs-b4)]! font-medium!">
          {selectedCount} selected · +{selectedCredits} credits
        </p>

        <div className="flex w-full items-center gap-2 md:w-auto">
          <Button variant="outline" onClick={onCancel} className="min-w-0 flex-1 md:flex-none">
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={onAdd}
            disabled={selectedCount === 0}
            className="min-w-0 flex-1 md:flex-none"
          >
            Add {selectedCount} {courseLabel}
          </Button>
        </div>
      </div>
    </div>
  );
};
